export async function fetchJavaVersions() {
  try {
    const res = await fetch(
      'https://api.adoptium.net/v3/info/available_releases'
    );
    const data = await res.json();
    // Return LTS and recent versions
    const versions = data.available_lts_releases || [];
    const recent = data.available_releases || [];
    const all = [...new Set([...versions, ...recent])].sort((a, b) => b - a);
    return all.map(String);
  } catch {
    return ['21', '17', '11', '8'];
  }
}

export async function fetchSpringBootVersions() {
  try {
    const res = await fetch('https://start.spring.io/metadata/client');
    const data = await res.json();
    const versions = data.bootVersion?.values || [];
    return versions
      .filter((v) => !v.id.includes('SNAPSHOT') && !v.id.includes('M') && !v.id.includes('RC'))
      .map((v) => v.id);
  } catch {
    return ['3.4.4', '3.3.7', '3.2.12'];
  }
}
